module.exports = __webpack_public_path__ + "static/media/zoom-minus.f40cb6d1.svg";